<div class="app-confirm-delete opacity-hide" [class.opacity-show]="open" class="{{positionClass}} {{positionClassV}}">
    <div class="title">{{'confirmdelete_title' | translate}}</div>
    <p>{{'confirmdelete_descr' | translate}}</p>
    <div class="d-flex justify-content-between">
        <button class="button cancel" (click)="cancel.emit(true)">{{'confirmdelete_no' | translate}}</button>
        <button class="button confirm" (click)="confirm.emit(true)">{{'confirmdelete_yes' | translate}}</button>
    </div>
</div>